module.exports = __webpack_public_path__ + "static/img/instruction250x250-02.8fd8f3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stdfastces/instruction250x250-02.png
// module id = TyqX
// module chunks = 0